__turbopack_context__.v({
  "button": "Bc5QGa_button",
  "button--primary": "Bc5QGa_button--primary",
  "button--secondary": "Bc5QGa_button--secondary",
  "button--tertiary": "Bc5QGa_button--tertiary",
  "button-wrapper": "Bc5QGa_button-wrapper",
  "button__arrow": "Bc5QGa_button__arrow",
  "button__arrow-wrapper": "Bc5QGa_button__arrow-wrapper",
});
